import shortUUID from 'short-uuid';

export const getTrimmedName = (name: string, length: number, limit: number) => {
  if (name?.length > limit) {
    const first = name.substring(0, length);
    const last = name.substring(name?.length - length);
    return `${first}...${last}`;
  }
  return name;
};

export const getHash = () =>
  typeof window !== 'undefined'
    ? decodeURIComponent(window.location.hash.replace('#', ''))
    : undefined;

export const isValidUUID = (uuid: string) => {
  return shortUUID().validate(uuid);
};

export const isEmpty = (value: unknown) => {
  if (value === null || value === undefined) return true;
  if (typeof value === 'string') return value.trim() === '';
  if (Array.isArray(value)) return value.length === 0;
  if (typeof value === 'object') return Object.keys(value).length === 0;
  return false;
};

export const withRetry = async <T>(fn: () => Promise<T>, retries = 3) => {
  for (let i = 0; i < retries; i++) {
    try {
      return await fn();
    } catch (error) {
      if (i === retries - 1) throw error;
    }
  }
};
